import React from "react";
import { getStripePortalUrl } from "../../../config/stripeConfig";
import styles from "./Subscribe.module.css";

export function SuccessDisplay({
  sessionId,
  userId,
}: {
  sessionId: string;
  userId: string;
}) {
  const returnBase =
    typeof window !== "undefined"
      ? `${window.location.origin}${window.location.pathname}`
      : "";

  // TODO create organization here?

  return (
    <div className={styles.pagePadding}>
      <div className={styles.successTitleRow}>
        <span className="page-title">You&apos;re subscribed</span>
      </div>
      <div className={styles.panel}>
        <p className={styles.successLead}>
          Your subscription is active. Manage billing anytime.
        </p>
        <form action={getStripePortalUrl()} method="POST">
          <input type="hidden" name="session_id" value={sessionId} />
          <input type="hidden" name="return_url" value={returnBase} />
          <button type="submit" className="proceed-button">
            Manage billing0123
          </button>
          <p>Username {userId}</p>
        </form>
      </div>
    </div>
  );
}
